<template>
  <div>
    <navbar-breadcrumb>
      <ol class="breadcrumb">
        <li class="breadcrumb-item active" aria-current="page">Dashboard</li>
      </ol>
    </navbar-breadcrumb>
    <div class="row justify-content-center">
      <div class="col-2">
        <el-date-picker
          v-model="month"
          type="month"
          size="medium"
          @change="getDashboard"
          :clearable="false"
          class="mb-2"
          format="MMMM yyyy"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="dashboard-summary mb-3">
          <div>
            <stats-card
              :title="formatNumero(dashboard.totals.national)"
              subTitle="Nacional"
            >
              <div slot="header">
                <i class="fa fa-home text-secondary"></i>
              </div>
              <template slot="footer">
                <i class="fa fa-calendar"></i>Mes anterior:
                {{ formatNumero(dashboard.totals.national_last) }}
              </template>
            </stats-card>
          </div>
          <div>
            <stats-card
              :title="formatNumero(dashboard.totals.international)"
              subTitle="Internacional"
            >
              <div slot="header">
                <i class="fa fa-globe text-secondary"></i>
              </div>
              <template slot="footer">
                <i class="fa fa-calendar"></i>Mes anterior:
                {{ formatNumero(dashboard.totals.international_last) }}
              </template>
            </stats-card>
          </div>
          <div
            v-for="(courier, key) in dashboard.couriers_total"
            :key="key"
          >
            <stats-card
              :title="formatNumero(courier.totales.current_month)"
              :subTitle="get_courier_text(courier.courier)"
            >
              <div slot="header">
                <img
                  :src="get_courier_logo(courier.courier)"
                  :alt="courier.courier"
                />
              </div>
              <template slot="footer">
                <i class="fa fa-calendar"></i>Mes anterior:
                {{ formatNumero(courier.totales.latest_month) }}
              </template>
            </stats-card>
          </div>
        </div>
        <div class="row pb-3">
          <div class="col-md-6 col-sm-12">
            <div class="card h-100">
              <div class="card-body">
                <h4 class="card-title card-title-seccion">Top 10 de ubicaciones de entrega</h4>
                <el-skeleton
                  animated
                  v-if="loading"
                  :rows="6"
                  class="w-100 p-2"
                  :style="chartStyles"
                />
                <CitiesPieChart
                  v-else
                  class="p-2"
                  :data="dashboard.cities"
                  :height="chartHeight"
                  :styles="chartStyles"
                />
              </div>
            </div>
          </div>
          <div class="col-md-6 col-sm-12">
            <div class="card h-100">
              <div class="card-body">
                <h4 class="card-title card-title-seccion">Top 10 servicios</h4>
                <el-skeleton
                  animated
                  v-if="loading"
                  :rows="4"
                  class="w-100 p-2"
                  :style="chartStyles"
                />
                <ServicesBarChart
                  v-else
                  class="p-2"
                  :data="dashboard.services"
                  :height="chartHeight"
                  :styles="chartStyles"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 col-sm-12">
            <div class="card">
              <div class="card-body">
                <h4 class="card-title card-title-seccion">Envíos por transporte</h4>
                <el-skeleton
                  animated
                  v-if="loading"
                  :rows="6"
                  class="w-100 p-2"
                  :style="chartStyles"
                />
                <PartnersChart
                  v-else
                  class="p-2"
                  :data="dashboard.couriers"
                  :month="month"
                  :height="chartHeight"
                  :styles="chartStyles"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { StatsCard } from "src/components/index";
import CitiesPieChart from "./Stats/CitiesPieChart.vue";
import PartnersChart from "./Stats/PartnersChart.vue";
import ServicesBarChart from "./Stats/ServicesBarChart.vue";
import { getCourierLogo, getCourierText } from "src/util/couriers";
import { formatNumero } from "@/util/utils";
export default {
  components: {
    StatsCard,
    CitiesPieChart,
    PartnersChart,
    ServicesBarChart,
  },
  data() {
    return {
      dashboard: {
        totals: {
          international: 0,
          national: 0,
          total: 0,
          international_last: 0,
          national_last: 0,
          total_last: 0,
        },
        cities: [],
        services: [],
        couriers: [],
        couriers_total: [],
      },
      loading: true,
      chartHeight: 260,
      month: "",
    };
  },
  mounted() {
    this.setMonth();
    this.getDashboard();
  },
  computed: {
    chartStyles() {
      return { height: `${this.chartHeight}px` };
    },
    dashboardStatus() {
      return this.$store.state.dashboard.entity.status;
    },
  },
  methods: {
    formatNumero,
    getDashboard() {
      const mes = this.month.getMonth() + 1;
      const anyo = this.month.getFullYear();
      this.$store.dispatch("dashboard/getDashboard", { mes, anyo });
    },
    notificacion(title, msg, typ) {
      this.$notify({
        title: title,
        message: msg,
        type: typ,
      });
    },
    get_courier_text: getCourierText,
    get_courier_logo: getCourierLogo,
    setMonth() {
      const today = new Date();
      this.month = new Date(today.getFullYear(), today.getMonth() - 1, 1);
    },
  },
  watch: {
    dashboardStatus(val) {
      if (val.loading) {
        this.loading = true;
      }

      if (val.error) {
        this.dashboard = {
          totals: {
            international: 0,
            national: 0,
            total: 0,
            international_last: 0,
            national_last: 0,
            total_last: 0,
          },
          cities: [],
          services: [],
          couriers: [],
          couriers_total: [],
        };
        this.loading = false;
      }

      if (val.loaded) {
        this.dashboard = this.$store.state.dashboard.entity.data;
        this.loading = false;
      }
    },
  },
};
</script>
<style scoped>
.dashboard-summary {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 8px;
}
</style>
